import { useMemo, useState, type ReactNode } from 'react';

import { MobileChromeContext } from './MobileChromeContext';

/** Owns the shell-chrome flags. Mounted in RootLayout, above both the trigger and the routes. */
export function MobileChromeProvider({ children }: { children: ReactNode }) {
    const [hideMobileTrigger, setHideMobileTrigger] = useState(false);

    // The setter identity is stable, so the value only changes when the flag does.
    const value = useMemo(() => ({ hideMobileTrigger, setHideMobileTrigger }), [hideMobileTrigger]);

    return <MobileChromeContext value={value}>{children}</MobileChromeContext>;
}
